export default __webpack_public_path__ + "static/media/social.1ad508d2.svg";